import * as tslib_1 from "tslib";
import updateQueryString from '../actions/updateQueryString';
import updateRecipientList from '../actions/updateRecipientList';
import updateRecipientWellDirty from '../actions/updateRecipientWellDirty';
import convertReadWriteRecipientToRecipientPersonaProps from '../utils/convertReadWriteRecipientToRecipientPersonaProps';
import createGenericItem from '../utils/createGenericItem';
import expandGroup from '../utils/expandGroup';
import getFloatingPickerProps from '../utils/getFloatingPickerProps';
import parsePastedTextForRecipients from '../utils/parsePastedTextForRecipients';
import searchDirectory from '../utils/searchDirectory';
import { observer } from 'mobx-react';
import { logUsage } from 'owa-analytics';
import ReadWriteCommonWell from 'owa-readwrite-common-well/lib/components/ReadWriteCommonWell';
import { oneRecipientSelectedAction } from 'owa-readwrite-recipient-well';
import ReadWriteRecipient from 'owa-readwrite-recipient-well/lib/components/ReadWriteRecipient';
import datapoints from 'owa-readwrite-recipient-well/lib/datapoints';
import isValidEmailAddress from 'owa-readwrite-recipient-well/lib/utils/isValidEmailAddress';
import { RecipientType } from 'owa-recipient-common/lib/store/schema/RecipientType';
import addFindPeopleEntityFromResults from 'owa-recipient-common/lib/utils/addFindPeopleEntityFromResults';
import removeFindPeopleEntity from 'owa-recipient-common/lib/utils/removeFindPeopleEntity';
import strings from 'owa-strings/owa-common-strings';
import * as React from 'react';
import { ExtendedPeoplePicker, } from 'office-ui-fabric-react/lib/ExtendedPicker';
import { subscribeToRecipientsChangeExternallyEvent, unsubscribeToRecipientsChangeExternallyEvent, } from '../actions/onRecipientsChangeExternally';
var SMTP_ROUTING_TYPE = 'SMTP';
var PRIVATE_DL_ROUTING_TYPE = 'PDL';
var ONE_OFF_MAILBOX_TYPE = 'OneOff';
var ComposeExtendedPeoplePicker = /** @class */ (function (_super) {
    tslib_1.__extends(ComposeExtendedPeoplePicker, _super);
    function ComposeExtendedPeoplePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // For now, we implement a custom backspace implementation that checks if the item
        // has blocked recipient removal before removing it. TO-DO 121156: When fabric
        // component is updated to support a callback for backspace checking, we will
        // pass this check as props to the ExtendedPeoplePicker component instead
        _this.onBackspace = function (ev) {
            if (ev.which !== 8 /* Backspace */) {
                return;
            }
            if ((_this.state.items.length && !_this.input.current) ||
                (_this.input.current && !_this.input.current.isValueSelected)) {
                if (_this.selectedItemsList.current &&
                    _this.input.current.cursorLocation === 0) {
                    var itemIndex = _this.items.length - 1;
                    var itemToRemove = _this.items[itemIndex];
                    if (itemToRemove && !itemToRemove.blockRecipientRemoval) {
                        _this.selectedItemsList.current.removeItemAt(itemIndex);
                        _this._onSelectedItemsChanged();
                    }
                }
            }
        };
        return _this;
    }
    return ComposeExtendedPeoplePicker;
}(ExtendedPeoplePicker));
export { ComposeExtendedPeoplePicker };
var ReadWriteFabricRecipientWell = /** @class */ (function (_super) {
    tslib_1.__extends(ReadWriteFabricRecipientWell, _super);
    function ReadWriteFabricRecipientWell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addItem = function (recipientsToAdd) {
            _this.picker.selectedItemsList.current.addItems(recipientsToAdd);
        };
        _this.getExtendedFindControlProps = function () {
            var floatingPickerProps = getFloatingPickerProps(_this.getViewState, _this.getFindControl);
            return tslib_1.__assign({}, floatingPickerProps, { onInputChanged: _this.onInputChanged });
        };
        _this.getExtendedSelectedItemsListProps = function () {
            return {
                onCopyItems: _this.copyAddresses,
                editMenuItemText: strings.readWriteRecipientMenu_Edit,
                removeMenuItemText: strings.readWriteRecipientMenu_Remove,
                copyMenuItemText: strings.readWriteRecipientMenu_Copy,
                onRenderFloatingPicker: _this.onRenderFindControl,
                floatingPickerProps: _this.getExtendedFindControlProps(),
                getEditingItemText: function (item) {
                    return item.displayText;
                },
            };
        };
        _this.onItemAdded = function (item) {
            var recipientWell = _this.props.extendedProps.recipientWell;
            var itemPosition = _this.getSelectedItemIndex(_this.picker.floatingPicker.current.suggestions, item);
            var _a = datapoints.AddRecipientFromFindControl.datapoint, eventName = _a.name, customData = _a.customData;
            logUsage(eventName, customData(itemPosition, recipientWell.findResultType));
            updateRecipientWellDirty(recipientWell, true);
            addFindPeopleEntityFromResults(recipientWell, item.persona, itemPosition);
            // If this is the first recipient added
            if (recipientWell.recipients.length === 0 && item.persona) {
                oneRecipientSelectedAction(item.persona);
            }
            return item;
        };
        _this.onItemRemoved = function (item) {
            var recipientWell = _this.props.extendedProps.recipientWell;
            updateRecipientWellDirty(recipientWell, true);
            removeFindPeopleEntity(recipientWell.findPeopleFeedbackManager, item);
            if (recipientWell.recipients.length === 2) {
                // If there is only one recipient left
                var lastRecipient = recipientWell.recipients.filter(function (recipient) { return recipient.persona !== item.persona; });
                if (lastRecipient && lastRecipient.length === 1) {
                    oneRecipientSelectedAction(lastRecipient[0].persona);
                }
            }
        };
        _this.addDroppedItem = function (item) {
            var droppedRecipientPersonaProps = tslib_1.__assign({ primaryText: item.persona.EmailAddress.Name }, item);
            _this.picker.selectedItemsList.current.addItems([droppedRecipientPersonaProps]);
        };
        _this.removeDroppedItem = function (item) {
            _this.removeRecipient(_this.props.extendedProps.recipientWell, _this.picker, false /*focus*/)(item);
        };
        _this.renderSelectedItem = function (props) {
            var _a = _this.props
                .extendedProps, recipientWell = _a.recipientWell, recipientSize = _a.recipientSize;
            var size = recipientSize ? recipientSize : 1 /* Regular */;
            var viewState = props.item;
            return (React.createElement(ReadWriteRecipient, { viewState: viewState, removeOperation: _this.removeRecipient(recipientWell, _this.picker), focusNextOperation: function () {
                    return;
                }, expandGroupOperation: _this.expandGroup(recipientWell), size: size, useContextMenu: false }));
        };
        _this.renderSuggestionItem = function (props, itemProps) {
            /** This method is passed as onRenderSuggestionsItem in the FloatingPickerProps in the base class
             *  For this class, onRenderSuggestionItems is taken care of by getFloatingPickerProps */
            return null;
        };
        _this.getZeroQuerySuggestions = function (currentItems) {
            /** This method is passed as onZeroQuerySuggestion in the FloatingPickerProps in the base class
             *  For this class, onZeroQuerySuggestion is taken care of by getFloatingPickerProps */
            return null;
        };
        _this.getQuerySuggestions = function (filterText, currentItems) {
            /** This method is passed as onResolveSuggestions in the FloatingPickerProps in the base class
             *  For this class, onResolveSuggestions is taken care of by getFloatingPickerProps */
            return null;
        };
        _this.getDefaultSelectedItems = function () {
            return convertReadWriteRecipientToRecipientPersonaProps(_this.props.extendedProps.recipientWell.recipients);
        };
        _this.onSelectedItemsChanged = function (items) {
            var _a = _this.props
                .extendedProps, recipientWell = _a.recipientWell, onRecipientsChanged = _a.onRecipientsChanged;
            updateRecipientList(recipientWell, items);
            updateQueryString(recipientWell, _this.picker.inputElement.value);
            onRecipientsChanged && onRecipientsChanged(recipientWell.recipients);
        };
        _this.getDisplayTextFromItem = function (item) {
            return item.displayText;
        };
        _this.getCanDragItem = function (item) {
            var dragItem = item;
            return !(dragItem.blockRecipientRemoval && dragItem.shouldBlockSelection);
        };
        _this.onKeyDown = function (ev) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var recipientWell, findControl;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(ev.ctrlKey && ev.which == 75 /* K */)) return [3 /*break*/, 2];
                        ev.preventDefault();
                        recipientWell = this.props.extendedProps.recipientWell;
                        findControl = this.getFindControl();
                        findControl.showPicker(true /*updateValue*/);
                        return [4 /*yield*/, searchDirectory(this.getViewState, this.getFindControl())];
                    case 1:
                        _a.sent();
                        if (recipientWell.findResultSet.length == 1) {
                            findControl.forceResolveSuggestion();
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.getViewState = function () {
            return _this.props.extendedProps.recipientWell;
        };
        _this.getFindControl = function () {
            return _this.picker ? _this.picker.floatingPicker.value : null;
        };
        _this.removeRecipient = function (recipientWell, peoplePicker, focus) {
            if (focus === void 0) { focus = true; }
            return function (recipientToRemove) {
                var indexToRemove = peoplePicker.selectedItemsList.current.items.indexOf(recipientToRemove);
                peoplePicker.selectedItemsList.current.removeItemAt(indexToRemove);
                removeFindPeopleEntity(recipientWell.findPeopleFeedbackManager, recipientToRemove);
                if (focus && recipientWell.recipients.length == 0) {
                    _this.focus();
                }
            };
        };
        _this.expandGroup = function (recipientWell) { return function (recipientToExpand) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var expandedEmails;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, expandGroup(this.props.extendedProps.recipientWell, recipientToExpand, this.picker)];
                    case 1:
                        expandedEmails = _a.sent();
                        this.picker.selectedItemsList.current.replaceItem(recipientToExpand, expandedEmails);
                        return [2 /*return*/];
                }
            });
        }); }; };
        _this.copyAddresses = function (recipientsToCopy) {
            var copyText;
            recipientsToCopy.forEach(function (recipient, index) {
                var email = recipient.persona.EmailAddress;
                if (email.RoutingType === SMTP_ROUTING_TYPE) {
                    if (email.Name) {
                        var nameToUse = email.MailboxType == ONE_OFF_MAILBOX_TYPE
                            ? email.Name
                            : "\"" + email.Name.replace('"', '\\"') + "\"";
                        copyText = nameToUse + " <" + email.EmailAddress + ">";
                    }
                    else {
                        copyText = email.EmailAddress;
                    }
                }
                else if (email.RoutingType === PRIVATE_DL_ROUTING_TYPE) {
                    copyText = email.Name;
                }
                else {
                    copyText = email.Name + " [" + email.RoutingType + ":" + email.EmailAddress + "]";
                }
                if (index < recipientsToCopy.length - 1) {
                    copyText += ', ';
                }
            });
            return copyText;
        };
        _this.onInputChanged = function (filterText) {
            var itemInserted = false;
            var lastCharIndex = filterText.length - 1;
            var lastChar = filterText[lastCharIndex];
            if (lastChar == ';' || lastChar == ',') {
                var itemText = filterText.substring(0, lastCharIndex);
                var addedItem = _this.createGenericItem(itemText, _this.isValidItemName(itemText));
                _this.picker.selectedItemsList.current.addItems([
                    addedItem.item,
                ]);
                _this.picker.clearInput();
                itemInserted = true;
            }
            updateQueryString(_this.props.extendedProps.recipientWell, itemInserted ? '' : filterText);
        };
        return _this;
    }
    ReadWriteFabricRecipientWell.prototype.componentDidMount = function () {
        if (this.props.extendedProps.recipientType ==
            RecipientType.To) {
            subscribeToRecipientsChangeExternallyEvent(this.picker.selectedItemsList
                .current);
        }
    };
    ReadWriteFabricRecipientWell.prototype.componentWillUnmount = function () {
        unsubscribeToRecipientsChangeExternallyEvent(this.picker.selectedItemsList
            .current);
    };
    ReadWriteFabricRecipientWell.prototype.typedPicker = function () {
        return ComposeExtendedPeoplePicker;
    };
    ReadWriteFabricRecipientWell.prototype.extendedPickerProps = function () {
        var extendedProps = this.props.extendedProps;
        return {
            headerComponent: extendedProps.onRenderWellLabel && extendedProps.onRenderWellLabel(extendedProps),
            inputProps: {
                placeholder: extendedProps.placeholderText,
            },
        };
    };
    ReadWriteFabricRecipientWell.prototype.parsePastedTextForItems = function (pastedText) {
        return parsePastedTextForRecipients(pastedText);
    };
    ReadWriteFabricRecipientWell.prototype.isValidItemName = function (itemText) {
        return isValidEmailAddress(itemText);
    };
    ReadWriteFabricRecipientWell.prototype.createGenericItem = function (itemText, isValid) {
        return createGenericItem(itemText, isValid);
    };
    ReadWriteFabricRecipientWell = tslib_1.__decorate([
        observer
    ], ReadWriteFabricRecipientWell);
    return ReadWriteFabricRecipientWell;
}(ReadWriteCommonWell));
export default ReadWriteFabricRecipientWell;
//# sourceMappingURL=ReadWriteFabricRecipientWell.js.map